export default function isRoundNumber(num) {
  return Number.isInteger(num);
}
